<template>
    <el-row :gutter="30" justify="center">
        <el-card :header="category.name" class="col-12 col-md-10 col-lg-8">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-row v-if="!category.id" justify="center" align="middle">
                        <el-col :sm="12" :lg="7">
                            <el-result
                                icon="error"
                                title="Categoria não encontrada"
                                sub-title="A categoria que procura não foi encontrada, por favor verifique se consta da lista"
                            >
                            </el-result>
                        </el-col>
                    </el-row>
                    <template v-else>
                        <el-form :rules="rules" ref="formRef" :model="category" :disabled="updating" label-position="top">
                            <el-row :gutter="20" justify="start">
                                <el-col :sm="24">
                                    <div class="d-flex justify-content-center" style="width: 100%;">
                                        <img v-if="uri" :src="uri" style="max-width: 170px;" />
                                    </div>
                                    <el-form-item prop="image" label="Selecione uma imagem">
                                        <el-input  type="file" ref="image" name="image" @change="selectImage" />
                                    </el-form-item>
                                </el-col>
                                <el-col :sm="24" :md="14" :lg="16">
                                    <el-form-item label="Nome da categoria" prop="name">
                                        <el-input v-model="category.name" name="name"  />
                                    </el-form-item>
                                </el-col>
                                
                                <el-col :sm="24" :md="10" :lg="8">
                                    <el-form-item label="Salvar">
                                        <el-button plain type="primary" size="large" :loading="updating" @click.prevent="update(formRef)">
                                            Salvar alterações
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>

                        <el-collapse accordion :model-value="['1']">
                            <el-collapse-item name="1" title="Produtos nesta categoria">
                                <PersonalTable :loading="loading" :height="350" :showRows="7" 
                                    :cols="[
                                        {label: 'Cod', prop: 'id'},
                                        {label: 'Nome', prop: 'name'},
                                        {label: 'Preço', prop: 'price'},
                                    ]" 
                                :data="category.products">
                                    <el-table-column align="center" label="Ver mais">
                                        <template #default="data">
                                            <el-button type="primary" @click="see(data.row)">
                                                <el-icon>
                                                    <View />
                                                </el-icon>
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </PersonalTable>
                            </el-collapse-item>
                        </el-collapse>
                    </template>
                </template>
            </el-skeleton>
        </el-card>
    </el-row>
</template>

<script lang="ts" setup>
    import PersonalTable from "@/components/PersonalTable.vue";
    import Api from "@/services/api";
    import { Category, Product } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRoute, useRouter } from "vue-router";
    // import { useStore } from "vuex";

    const route = useRoute()
    const router = useRouter()
    const {id} = route.params
    const loading = ref<boolean>(true)
    const updating = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    
    const category = reactive<Category>({
        name: ''
    })

    const rules = reactive<FormRules<Product>>({
        name: [{required: true, message: 'Insira o nome da categoria'}],
    })

    const image = ref()
    const uri = ref<string>()
    const imageFile = ref<File | Blob>()

    const selectImage = () => {
        imageFile.value = image.value?.input.files[0]
        uri.value = URL.createObjectURL(imageFile.value as File)
    }

    const getCategory = async () => {
        updating.value = true
        const res = await Api.get('admin/categories/' + id)
        if (res.status == 200) {
            const data = res.data.category
            category.name = data.name
            category.image = data.image
            uri.value = `${Api.publicUrl}/images/categories/${category.image?.url}`
            category.id = data.id
            category.products = data.products
        } else if (res.status != 404) {
            ElMessageBox.alert('Ocorreu um erro ' + res.data.message, {type: "error"}).then(() => router.push('/products')).catch(() => router.push('/products'))
        }
        updating.value = false
    }

    onBeforeMount(async () => {
        loading.value = true

        await getCategory()

        loading.value = false
    })

    const update = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                updating.value = true
                const form = new FormData()
                if (category.name) {
                    form.append("name", category.name)
                }
                if (imageFile.value) {
                    form.append("image", imageFile.value)
                }

                const res = await Api.post('admin/categories/' + id, category, form)
                console.log(res.data)

                if (res.status == 200) {
                    ElMessage.success({message: 'Actualizado com sucesso'})
                    // location.reload()
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                updating.value = false
            }
        })
    }

    const see = (product: Product) => {
        router.push('/products/' + product.id)
    }
</script>
